import { useLayoutEffect, useRef, useState } from "react";
import { Newspaper } from "lucide-react";

export default function NewsCard({ article }) {
  const summaryRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [clamped, setClamped] = useState(false);

  useLayoutEffect(() => {
    const el = summaryRef.current;
    if (el && !expanded) setClamped(el.scrollHeight > el.clientHeight + 1);
  }, [article.summary, expanded]);

  return (
    <article data-testid={`news-card-${article.id}`} className="card-tactical flex h-full flex-col overflow-hidden p-6 transition-transform hover:-translate-y-1">
        {article.image_url && (
          <img src={article.image_url} alt="" loading="lazy" data-testid={`news-image-${article.id}`}
            className={`-mx-6 -mt-6 mb-4 h-56 w-[calc(100%+3rem)] max-w-none bg-[#060B18] object-contain`} />
        )}
        {article.featured && (
          <span data-testid={`news-featured-${article.id}`} className="mb-2 inline-flex w-fit items-center gap-1 rounded-md bg-orange-500 px-2 py-1 text-[11px] font-black uppercase tracking-widest text-[#060B18]">
            À la une
          </span>
        )}
      <div className="mb-3 flex items-center justify-between">
        <span className="rounded-md border border-orange-500/40 bg-orange-500/10 px-2 py-1 text-[11px] font-bold uppercase tracking-widest text-orange-400">
          {article.category}
        </span>
        <span className="text-xs text-slate-500">{article.date}</span>
      </div>
      <h3 className="text-xl font-bold uppercase leading-tight tracking-tight">{article.title}</h3>
      <div className="mt-3 flex-1">
        <p ref={summaryRef} className={`whitespace-pre-line text-sm leading-relaxed text-slate-400 ${expanded ? "" : "line-clamp-4"}`}>
          {article.summary}
        </p>
        {(clamped || expanded) && (
          <button type="button" onClick={() => setExpanded(!expanded)} aria-expanded={expanded}
            data-testid={`news-toggle-${article.id}`}
            className="mt-2 inline-flex min-h-[44px] items-center text-xs font-bold uppercase tracking-widest text-orange-400 hover:text-orange-300">
            {expanded ? "Voir moins" : "Voir plus"}
          </button>
        )}
      </div>
      <div className="mt-4 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-slate-500">
        <Newspaper className="h-4 w-4 text-orange-500" /> Emisphere Esport
      </div>
    </article>
  );
}
